import { GoogleAdsTag } from '../analytics/GoogleAdsTag';
import { GoogleAnalytics } from '../analytics/GoogleAnalytics';
import { MetaPixel } from '../analytics/MetaPixel';
import { useCookieConsent } from '../hooks/useCookieConsent';
import { CookieBanner } from './CookieBanner';
import { CookiePreferencesModal } from './CookiePreferencesModal';
import { CookieSettingsButton } from './CookieSettingsButton';

/**
 * Punto di montaggio unico della UI cookie. Va reso dentro <BrowserRouter>
 * (usa <Link>) e dentro <CookieConsentProvider>.
 */
export function CookieConsentRoot() {
  const { showBanner, isPreferencesOpen } = useCookieConsent();

  return (
    <>
      {showBanner && !isPreferencesOpen && <CookieBanner />}
      <CookiePreferencesModal />
      <CookieSettingsButton />
      <GoogleAnalytics />
      <GoogleAdsTag />
      <MetaPixel />
    </>
  );
}
